import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "url-polyfill";

import Converse from "@sopranodesign/pulse-converse-boost";

Converse.render();
